import { createReducer } from '@reduxjs/toolkit';

import patchOrderedParts from '../../../thunks/coilovers/orderedParts/patchOrderedParts';
import { clearPatchOrderedParts } from '../../../actions/coilovers/orderedParts/patchOrderedParts';

const initialState = {
  loading: false,
  error: null,
  data: {},
};

const patchOrderedPartsReducer = createReducer(initialState, {
  [patchOrderedParts.pending]: (state) => ({
    ...state,
    loading: true,
    error: null
  }),
  [patchOrderedParts.fulfilled]: (state, { payload }) => ({
    ...state,
    loading: false,
    data: payload,
  }),
  [patchOrderedParts.rejected]: (state, { payload }) => ({
    ...state,
    loading: false,
    error: payload,
  }),
  [clearPatchOrderedParts]: () => initialState
});

export default patchOrderedPartsReducer;
